import { type Page } from '#shared/api/schema';
import {
    CONSTRUCTOR_ALIASES_WITH_TEMPLATES,
    CONSTRUCTOR_CART_ALIAS,
    CONSTRUCTOR_CART_PAGES,
    CONSTRUCTOR_CART_PREVIEW_ALIAS,
} from '../constants';

export const isConstructorCartPageGroup = (group: Page | Page[]): boolean =>
    Array.isArray(group) && CONSTRUCTOR_CART_PAGES.every((alias) => group.some((page) => page.alias === alias));

export const getConstructorCartPageItemTitle = (page: Page) =>
    page.alias === CONSTRUCTOR_CART_ALIAS ? 'Страница корзины' : page.title;

export const groupConstructorPagesByAlias = (pages: Page[]) => {
    const cartPages = CONSTRUCTOR_CART_PAGES.map((alias) => pages.find((page) => page.alias === alias)).filter(
        (page): page is Page => Boolean(page)
    );
    const hasCartGroup = cartPages.length === CONSTRUCTOR_CART_PAGES.length;
    const pagesToGroup = hasCartGroup ? pages.filter((page) => page.alias !== CONSTRUCTOR_CART_PREVIEW_ALIAS) : pages;

    return pagesToGroup
        .reduce<Page[][]>((acc, page) => {
            if (hasCartGroup && page.alias === CONSTRUCTOR_CART_ALIAS) {
                acc.push(cartPages);

                return acc;
            }

            const lastGroup = acc.length > 0 ? acc[acc.length - 1] : null;

            if (page.alias && page.alias === lastGroup?.[0]?.alias) {
                // Если последний элемент в аккумуляторе — группа с тем же alias, добавляем в неё элемент
                lastGroup.push(page);
            } else {
                // Иначе создаём новую группу
                acc.push([page]);
            }

            return acc;
        }, [])
        .map((group) =>
            group.length === 1 && !CONSTRUCTOR_ALIASES_WITH_TEMPLATES.includes(group[0].alias)
                ? group[0]
                : group.sort((pageA, pageB) => {
                      if (pageA.variant_type === 'default' && pageB.variant_type !== 'default') {
                          return -1;
                      }

                      if (pageB.variant_type === 'default' && pageA.variant_type !== 'default') {
                          return 1;
                      }

                      return 0;
                  })
        );
};
